import { render, staticRenderFns } from "./CampaignStepReview.vue?vue&type=template&id=6d096139&scoped=true"
import script from "./CampaignStepReview.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignStepReview.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CampaignStepReview.vue?vue&type=style&index=0&id=6d096139&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d096139",
  null
  
)

export default component.exports